(function () {
  if (!window.ProductDecoration) {
    window.ProductDecoration = {};
  }

  /* ============================
     VALID RUN CHARGES
  ============================ */
  window.ProductDecoration.validRunCharges = [
    "TruColor Large Imprint – Textile",
    "TRU.0 2-Sided Run Charge",
    "Digital Laminate Panel Additional Location",
    "GeoPanel Running Charge",
    "TruColor Uniball Run Charge",
    "2 Color Running Charge",
    "Utensil Laser Engraving",
    "TruColor Additional Location Run Charge",
    "TruColor Run Charge Handled",
    "TRU.0 Full Wrap Run Charge",
    "PT Run Charge Imprint single",
    "TruColor Running Charge (up to 3 sq in)",
    "Pad Print Uniball Run Charge",
    "PT Run Charge Embroidery Over 8k",
    "Symglasss Additional Color",
    "PT Run Charge Embroidery per 1K",
    "Personalization",
    "Laser Mug Running Charge",
    "3-4 Color Drinkware Chg",
    "PT Run Charge Imprint",
    "TruColor Running Charge",
    "Digital Panel Upgrade",
    "PT Set-up Imprint Multi color",
    "TruColor Large Imprint",
    "Embroidery Running Charge up to 8,000",
    "TRU.0 Half Wrap Run Charge",
    "Additional Color/Location",
    "2nd Laser Run Charge",
    "Embroidery Running Charge over 8,001",
    "On-Demand Personalization",
    "Laser Additional Location Charge",
    "Optional Laser on Blades",
    "Laser Oxidation Charge",
    "Reassembly Fee",
    "2-Color to 4-Color Imprint",
    "2-color to 4-Color Run Charge",
    "Additional Imprint Colors",
    "Full Color Bleed",
    "Full Color Imprint",
    "Laser Run Charge",
    "Magnetic Backing",
    "Writing Board Run Charge",
    "Chenille Patch",
    "Die Mold Transfers Run",
    "Digital Print Transfer Run",
    "Embroidery Run",
    "Headwear Patch Run",
    "Heat Transfer Run",
    "Laser Applique Colors Run",
    "Laser Applique Stitching Run",
    "Laser Etching Run",
    "Laser Tech Patch Run",
    "Reverse Applique Run",
    "Screen Printing Run",
    "Sequin Embroidery Run",
    "Additional Colors",
    "Additional Location Run Charge",
    "Additional Locations",
    "Additional Locations - Oxidation",
    "Additional Stitches",
    "ColorSplash 3D",
    "Initial Run Charge",
    "LaserXTREME Run Charge",
    "Oxidation Required"
  ];

  /* ============================
     VALID SETUP CHARGES
  ============================ */
  window.ProductDecoration.validSetupCharges = [
    "PT Set-up Kit",
    "PT Set-up Embroidered",
    "EMBROIDERY Set-up over 8,001 stitches",
    "On Demand Set Up Charge",
    "Setup Charge: Laser",
    "Symglass Set up Charge",
    "Washable Marker Set",
    "Setup Pad Uniball",
    "Golf Magnet Clip",
    "PT Set-up Imprinted Single",
    "Upgraded Carabiner Clip",
    "Embroidery Setup Charge Up to 8,000 Stitches",
    "FREE Setup Uniball TC",
    "PT Set-up Imprinted",
    "Crayola (10) Piece Fabric Marker Set",
    "Set-up Tru.0",
    "Setup Charge: Deboss",
    "Set-up TruColor",
    "Setup Charge",
    "PT Set-up Imprinted Multi color",
    "LTM Charge",
    "Chenille Setup",
    "Die Mold Transfers Setup",
    "Direct To Film Heat Transfers Setup",
    "Embroidery Setup",
    "Headwear Patch Setup",
    "Heat Transfer Setup",
    "Laser Applique Setup",
    "Laser Etching Setup",
    "Laser Tech Patch Setup",
    "Reverse Applique Setup",
    "Screen Printing Setup",
    "Sequin Embroidery Setup",
    "Additional Colors / Locations",
    "Additional Designs",
    "Additional Locations",
    "Additional Logos",
    "Additional Logos / Locations",
    "Additional Stitches",
    "Color Change",
    "Initial Setup Charge"
  ];
})();
